import { FC } from 'react'
import { FeedbackMessage, Stack } from '@instabox/consumer-web-ui'
import { FormattedMessage } from 'react-intl'
import { useRouter } from 'next/router'

import PlaceCard from '../PlaceCard'
import PlaceCardSkeleton from '../PlaceCard/PlaceCardSkeleton'
import { Place } from '../../models/place'
import EmptyList from './EmptyList'
import { usePlaces } from '../../contexts/PlacesProvider'
import styles from './placesList.module.scss'

export interface PlacesListProps {}

const PlacesList: FC<PlacesListProps> = () => {
  const { places, loading, error } = usePlaces()
  const { push } = useRouter()

  if (loading) {
    return (
      <Stack className={styles.list}>
        <PlaceCardSkeleton />
        <PlaceCardSkeleton />
        <PlaceCardSkeleton />
      </Stack>
    )
  }

  if (error) {
    return (
      <FeedbackMessage align="center" className={styles.error}>
        <FormattedMessage id="places.error" />
      </FeedbackMessage>
    )
  }

  if (places.length === 0) {
    return <EmptyList />
  }

  return (
    <Stack className={styles.list}>
      {places.map((place: Place) => (
        <PlaceCard key={place.id} {...place} onClick={() => push(`/places/${place.id}`)} />
      ))}
    </Stack>
  )
}

export default PlacesList
